//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
    components: {},
    props: [],
    data () {
        return {
            tableData: [],
            // tableHeight:''
            pgData:{
                pagesize:10
            },
            kplxList:[
                {key:0,value:'正票',type:'primary'},
                {key:1,value:'负票',type:'danger'},
            ]
        }
    },
    computed: {
    
    },
    watch: {

    },
    methods: {
        //筛选状态
        filterDiyData:function(arr,val){
            let status =  arr.filter(function(item){
                return item.key == val ;
            })
            if(status.length != 0){
                return status[0]; //返回筛选的对象
            } else{
                return {};
            }
        },
        downloadFP: function(val){
            if(!!val){
                window.open(val);
            }else{
                ShowMsg.call(this,'发票文件不存在','warning');
            }
        },
    },
    mounted: function() {
    }
}
